export const getAdminUrls = (templateId: number) => ({
  settings: `/administration/templates/template-builder/${templateId}/settings`,
  presentation: `/administration/templates/template-builder/${templateId}/presentation-model`,
  data: `/administration/templates/template-builder/${templateId}/data-model`,
});
